import {
  Button,
  CircularProgress,
  Grid,
  Modal,
  styled,
  Typography,
  useMediaQuery,
} from "@mui/material";
import React from "react";

import "./index.css";
import { useTheme } from "@emotion/react";

const StyledButton = styled(Button)(({ theme }) => ({
  background: "#4D6BF6",
  color: "#ffffff",
  boxShadow: "none",
  border: "1px solid #4D6BF6",
  whiteSpace: "nowrap",
  fontSize: "16px",
  fontWeight: "500",
  borderRadius: "10px",
  padding: ".5vh 1vw",
  letterSpacing: "0",
}));

const GreyStyledButton = styled(Button)(({ theme }) => ({
  background: "#fff",
  color: "#0D0D0E",
  boxShadow: "none",
  border: "1px solid #D7D8D9",
  whiteSpace: "nowrap",
  fontSize: "16px",
  fontWeight: "500",
  borderRadius: "10px",
  padding: ".5vh 1vw",
  letterSpacing: "0",
}));

export default function ConfirmModel(props) {
  const {
    message = "",
    visible = false,
    handleClose = () => null,
    confirmation = () => null,
    loader = false,
    title = "",
    titleText = "",
  } = props;

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  return (
    <Modal
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: isMobile ? "16px" : "0",
      }}
      disableAutoFocus
      open={visible}
    >
      <Grid
        item
        xs={isMobile ? 12 : 10}
        sm={8}
        md={6}
        lg={4}
        justifyContent={"center"}
        alignItems={"center"}
        style={{
          backgroundColor: "#FFF",
          borderRadius: isMobile ? "12px" : "12px",
          padding: isMobile ? "24px 20px" : "40px",
          width: isMobile ? "100%" : "30vw",
          maxWidth: isMobile ? "380px" : "500px",
          margin: isMobile ? "auto" : "0",
        }}
      >
        <Grid item>
          {titleText && (
            <Typography
              style={{
                color: "#0D1522 ",
                fontFamily: "Inter Tight",
                fontSize: isMobile ? "16px" : "18px",
                letterSpacing: "0.5px",
                lineHeight: "24px",
                fontWeight: "bold",
                textAlign: "center",
                marginBottom: "10px",
              }}
            >
              {titleText}
            </Typography>
          )}
          <Typography
            style={{
              color: "#0D1522",
              fontFamily: "Inter Tight",
              fontSize: isMobile ? "14px" : "16px",
              letterSpacing: "0.5px",
              lineHeight: isMobile ? "20px" : "24px",
              fontWeight: "500",
              textAlign: "center",
              marginBottom: "24px",
            }}
          >
            {message}
          </Typography>
        </Grid>
        <Grid
          item
          container
          justifyContent={"center"}
          gap={isMobile ? 1 : 2}
          wrap="nowrap"
          marginTop={"10px"}
        >
          <Grid item xs={6}>
            <GreyStyledButton
              fullWidth
              onClick={handleClose}
              sx={{
                fontSize: isMobile ? "14px" : "16px",
                padding: isMobile ? "8px 16px" : ".5vh 1vw",
              }}
            >
              Cancel
            </GreyStyledButton>
          </Grid>
          <Grid item xs={6}>
            <StyledButton
              fullWidth
              variant="contained"
              onClick={confirmation}
              disabled={loader}
              sx={{
                fontSize: isMobile ? "14px" : "16px",
                padding: isMobile ? "8px 16px" : ".5vh 1vw",
              }}
            >
              {loader ? (
                <CircularProgress
                  style={{ color: "#fff" }}
                  size={isMobile ? 20 : 26}
                />
              ) : title ? (
                title
              ) : (
                "Confirm"
              )}
            </StyledButton>
          </Grid>
        </Grid>
      </Grid>
    </Modal>
  );
}
